import { Input, Popover } from "@mantine/core";
import { ComponentProps } from "react";

import { colors } from "#app/theme/v1/colors";
import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { Group } from "#shared/view/components/Group";
import { Text } from "#shared/view/components/Text";

const SIZE = 15;

export const Label = (
  props: ComponentProps<typeof Input.Label> & {
    helper: string | undefined;
    onClickWhy?: () => void;
  },
) => {
  const { helper, onClickWhy, ...rest } = props;
  const hasHelper = !!helper;
  const isHelperUrl = helper?.includes("https");

  return (
    <Group gap={"xs"} align="flex-start">
      <Input.Label {...rest} m={0}>
        {rest.children}
      </Input.Label>

      {hasHelper &&
        (isHelperUrl ? (
          <ActionIcon
            size={SIZE + 5}
            color="gray"
            component="a"
            target="_blank"
            rel="noopener noreferrer"
            href={helper}
          >
            <Icon name="infoCircle" size={SIZE} />
          </ActionIcon>
        ) : (
          <Popover
            width={300}
            position="bottom"
            withArrow
            shadow="md"
            styles={{ dropdown: { backgroundColor: colors.gray[1] } }}
          >
            <Popover.Target>
              <ActionIcon size={SIZE + 5} color={"gray.5"}>
                <Icon name="infoCircle" size={SIZE} />
              </ActionIcon>
            </Popover.Target>
            <Popover.Dropdown>
              <Text size="sm">{helper}</Text>
            </Popover.Dropdown>
          </Popover>
        ))}
      {onClickWhy && (
        <ActionIcon size={SIZE + 5} color="gray" onClick={onClickWhy}>
          <Icon name="help" size={SIZE} />
        </ActionIcon>
      )}
    </Group>
  );
};
